<template>
    <div>
      <el-row>
        <el-col>
            <el-date-picker v-model="dateRange" class="filter-item" type="daterange" value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="查詢起始日期" end-placeholder="查詢結束日期" 
            :picker-options="pickerOptions" />
        </el-col>

        <!-- <el-col :span="7">
            <div class="filter-label">
                採購編號: 
            </div>
            <el-select v-model="pn"  filterable  class="filter-item" placeholder="採購編號" clearable="true"
                :loading="select_loading" loading-text="取得資料中..." no-match-text="無符合資料" no-data-text="無資料">
                <el-option v-for="e in pns" :key="e" :label="e" :value="e" />
            </el-select>
        </el-col>
        <el-col :span="7">
            <div class="filter-label">
                契約案號: 
            </div>
            <el-select v-model="cn"  filterable  class="filter-item" placeholder="契約編號" clearable="true"
            :loading="select_loading" loading-text="取得資料中..." no-match-text="無符合資料" no-data-text="無資料">
                <el-option v-for="e in cns" :key="e" :label="e" :value="e" />
            </el-select>
        </el-col> -->
        </el-row>
        <el-divider content-position="right">
            <div class="right">
                <el-button type="primary" icon="el-icon-search" @click="search()" size="small" >查詢</el-button>
                <el-button type="primary" icon="el-icon-bottom" @click="exportReport()" size="small" >下載</el-button>
            </div>  
        </el-divider>
        <el-row class="mb-10">
            <el-table ref="dailyRawdataTable" 
                v-loading="loading" 
                element-loading-text="請求資料中" 
                element-loading-spinner="el-icon-loading" 
                element-loading-background="rgba(0, 0, 0, 0.8)" 
                :header-cell-style="{color:'#20638C'}" 
                :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                @sort-change="sortChange"
                style="width: 100%;"
                :cell-style="{padding: '0', height: '40px'}" >
                <el-table-column :fixed="getFixed(0)" align="center" prop="recordedOn" label="日期" sortable :show-overflow-tooltip="true"  width="150" />
                <el-table-column :fixed="getFixed(1)" align="center" prop="_volume" label="估算用水量(度)" sortable :show-overflow-tooltip="true"  width="140" />
                <el-table-column :fixed="getFixed(2)" align="center" prop="_compareToYesterday" :label="compareToYesterdayLabel" sortable :show-overflow-tooltip="true"  width="130">
                    <template slot-scope="scope">
                            <el-tag v-show="scope.row._volume !== '' && scope.row._compareToYesterday !== ''" :type="scope.row._compareToYesterday >0 ? 'success' : scope.row._compareToYesterday < 0 ? 'danger' : 'info'" disable-transitions>
                                <div v-show="scope.row._compareToYesterday > 0">
                                    {{scope.row._compareToYesterday}}%<i class="el-icon-top" />
                                </div>
                                <div v-show="scope.row._compareToYesterday == 0">
                                    {{scope.row._compareToYesterday}}%
                                </div>
                                <div v-show="scope.row._compareToYesterday < 0">
                                    {{scope.row._compareToYesterday}}%<i class="el-icon-bottom" />
                                </div>
                            </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="回傳指針數">
                    <el-table-column  align="center" prop="_rawdata[0]" label="00時" width="125"/>
                    <el-table-column  align="center" prop="_rawdata[1]" v-if="volumeViewTimeUnit=='hour'" label="01時" width="125"/>
                    <el-table-column  align="center" prop="_rawdata[2]" v-if="volumeViewTimeUnit=='hour'" label="02時" width="125"/>
                    <el-table-column  align="center" prop="_rawdata[3]" v-if="volumeViewTimeUnit=='hour'" label="03時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[4]" v-if="volumeViewTimeUnit=='hour'" label="04時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[5]" v-if="volumeViewTimeUnit=='hour'" label="05時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[6]" v-if="volumeViewTimeUnit=='hour'" label="06時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[7]" v-if="volumeViewTimeUnit=='hour'" label="07時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[8]" v-if="volumeViewTimeUnit=='hour'" label="08時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[9]" v-if="volumeViewTimeUnit=='hour'" label="09時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[10]" v-if="volumeViewTimeUnit=='hour'" label="10時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[11]" v-if="volumeViewTimeUnit=='hour'" label="11時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[12]" v-if="volumeViewTimeUnit=='hour'" label="12時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[13]" v-if="volumeViewTimeUnit=='hour'" label="13時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[14]" v-if="volumeViewTimeUnit=='hour'" label="14時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[15]" v-if="volumeViewTimeUnit=='hour'" label="15時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[16]" v-if="volumeViewTimeUnit=='hour'" label="16時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[17]" v-if="volumeViewTimeUnit=='hour'" label="17時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[18]" v-if="volumeViewTimeUnit=='hour'" label="18時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[19]" v-if="volumeViewTimeUnit=='hour'" label="19時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[20]" v-if="volumeViewTimeUnit=='hour'" label="20時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[21]" v-if="volumeViewTimeUnit=='hour'" label="21時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[22]" v-if="volumeViewTimeUnit=='hour'" label="22時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[23]" v-if="volumeViewTimeUnit=='hour'" label="23時" width="125" />
                    <el-table-column  align="center" prop="_rawdata[24]" v-if="volumeViewTimeUnit=='hour'" label="24時" width="125" />
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <el-col>    
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage"
                  :total="this.tableData.length" @current-change="setPage" @size-change="changePages" :page-sizes="page_size_options"
                  style="max-width: 100% ;overflow-x: auto !important;"/>
            </el-col>
        </el-row>
    </div>    
</template> 

<script>
import _ from 'lodash'
import {viewRuleSetting} from '@/components/common'
import moment from 'moment-timezone'
export default {
    name: 'DailyRawdata',
    components: {
        
    },

    data() {
        return {
            fixedColumns: [true,true,true],
            loading: false,
            dateRange: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近7天',
                        onClick(picker)
                        {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近14天',
                        onClick(picker)
                        {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
                        picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近30天',
                        onClick(picker) 
                        {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    }]
            },
            waterId: "",
            tableData: [],
            currentPage: 1, 
            pageSize: 10,
            page_size_options: [10, 25, 50, 75, 100, 150, 200, 300],
            volumeViewTimeUnit: 'hour',
            settingData: {
                viewType: '',
                waterId: '',
                immutable: false,
                usageViewTimeUnit: '',
                volumeViewTimeUnit: ''
            },
            compareToYesterdayLabel: '較前一日增減',
            sortTmp: ""
    }
  },
    watch: {

    },
    created() {
        // 設定預設起始日期,20230518
        const beginDate = moment().subtract(1, 'month').format('YYYY-MM-DD');
        // 設定預設結束日期,20230518
        const endDate = moment().format('YYYY-MM-DD');
        this.dateRange.push(beginDate)
        this.dateRange.push(endDate)        
    },
    async mounted() {
        await this.getTimeUnitValue()
        localStorage.setItem('DailyRawdata', '2023-06-02 14:30 changed.')
        // 預設進入畫面自動搜尋,20230518
        this.search()
        this.webModeCheck()
    },
    computed:{
        currentWaterId()
        {
            return JSON.parse(localStorage.getItem('currentProfile')).waterId
        }
    },
    methods: {
        search()
        {
            if( ! _.size(this.dateRange))
            {
                return this.$message({ message: '請選擇時間區間!', type: 'warning' }) 
            }
            // 往前多撈取一個時間單位
            const reqStartDate = this.getPrevTime(this.dateRange[0])
            // 往後多撈取一個時間單位
            const reqEndDate = this.getNextTime(this.dateRange[1])
            let url = "/api/report/profile/" + this.currentWaterId + "/dailyRawdata?start=" + reqStartDate + "&end=" + reqEndDate
            this.loading = true
            this.axios.get(url).then( res =>
            {
                if(_.isArray(res.data))
                {
                    for (let i = 0; i < res.data.length; i++) {
                        const current = res.data[i]   //目前資料
                        let last = null // 前一筆資料
                        let next = null // 下一筆資料
                        if(i > 0) {
                            last = res.data[i - 1]
                        }
                        if(i < res.data.length - 1) {
                            next = res.data[i + 1]
                        }

                        // 設定預設資料
                        let _rawdata = ['','','','','','','','','','','','','','','','','','','','','','','','','']

                        current["_compareToYesterday"] = ''
                        current["_volume"] = ''

                        // 如果估算用水量 及 rawdata不為空
                        if (this.isNotEmptyButZero(current["volume"]) && current["rawdata"]) {
                            // 轉換「較前一日增減」百分比
                            let _compareToYesterday = Math.round(current["compareToYesterday"] * 10000) / 100
                            if(last) {
                                // 上一筆資料的估算用水量不為空，且不為0
                                if(last["_volume"] && parseFloat(last["_volume"]) !== 0) {
                                    current["_compareToYesterday"] = _compareToYesterday
                                }
                            } else {
                                // 第一筆資料
                                current["_compareToYesterday"] = _compareToYesterday
                            }
                            
                            // 若 當日沒有00時的資料 或 (下一筆資料的rawdata為空 或 下一筆資料的rawdata的「00時」為空)，則不顯示估算用水量
                            if(!current.rawdata[this.$moment(current.recordedOn).format('YYYY-MM-DD[T]00:00')] 
                                || (next && (!next.rawdata || !next.rawdata[this.$moment(next.recordedOn).format('YYYY-MM-DD[T]00:00')]))) {
                                current["_volume"] = ''
                            } else {
                                current["_volume"] = (Math.round(current["volume"] * 10000) / 10000).toFixed(2)
                            }
                            
                            // 如果目前「估算用水量」無資料，則不顯示「較前一日增減」
                            if(!current["_volume"]) {
                                current["_compareToYesterday"] = ''
                            }


                            // 取得主要日期
                            const majorityDate = this.getMajorityDate(current.rawdata)

                            _.forEach(current.rawdata, (v, k) => {
                                // _rawdata.push( Math.round(v.volume * 10000) / 100)
                                // 修改成直接顯示Response的數值,20230519
                                // _rawdata.push(v.volume)

                                // 將位數四捨五入至小數第四位,20230619
                                // 1. visible 確認是否遮蔽 2. volumeAdjusted 為null才用 volume (20250314)
                                if (v["visible"]) {
                                    v["_volume"] = v["volumeAdjusted"] ? (Math.round(v["volumeAdjusted"] * 10000) / 10000).toFixed(4) : (Math.round(v["volume"] * 10000) / 10000).toFixed(4)
                                } else {
                                    v["_volume"] =  '' 
                                }

                                const hour = this.$moment(k).format('HH')

                                // 主要日期補上00~23資料
                                if (this.$moment(k).isSame(majorityDate, 'day')) {
                                    switch (hour) {
                                        case '00':
                                            _rawdata[0] = v['_volume']
                                            break
                                        case '01':
                                            _rawdata[1] = v['_volume']
                                            break
                                        case '02':
                                            _rawdata[2] = v['_volume']
                                            break
                                        case '03':
                                            _rawdata[3] = v['_volume']
                                            break
                                        case '04':
                                            _rawdata[4] = v['_volume']
                                            break
                                        case '05':
                                            _rawdata[5] = v['_volume']
                                            break
                                        case '06':
                                            _rawdata[6] = v['_volume']
                                            break
                                        case '07':
                                            _rawdata[7] = v['_volume']
                                            break
                                        case '08':
                                            _rawdata[8] = v['_volume']
                                            break
                                        case '09':
                                            _rawdata[9] = v['_volume']
                                            break
                                        case '10':
                                            _rawdata[10] = v['_volume']
                                            break
                                        case '11':
                                            _rawdata[11] = v['_volume']
                                            break
                                        case '12':
                                            _rawdata[12] = v['_volume']
                                            break
                                        case '13':
                                            _rawdata[13] = v['_volume']
                                            break
                                        case '14':
                                            _rawdata[14] = v['_volume']
                                            break
                                        case '15':
                                            _rawdata[15] = v['_volume']
                                            break
                                        case '16':
                                            _rawdata[16] = v['_volume']
                                            break
                                        case '17':
                                            _rawdata[17] = v['_volume']
                                            break
                                        case '18':
                                            _rawdata[18] = v['_volume']
                                            break
                                        case '19':
                                            _rawdata[19] = v['_volume']
                                            break
                                        case '20':
                                            _rawdata[20] = v['_volume']
                                            break
                                        case '21':
                                            _rawdata[21] = v['_volume']
                                            break
                                        case '22':
                                            _rawdata[22] = v['_volume']
                                            break
                                        case '23':
                                            _rawdata[23] = v['_volume']
                                            break
                                    }
                                } else {
                                    // 非主要資料將00填入第24時
                                    _rawdata[24] = v['_volume']
                                }

                            })  // end rawdata foreach
                        }   // end if  

                        current["_rawdata"] = _rawdata
                    }   // end for

                    // 由於有往前多撈取一個時間單位，因此移除第一筆資料
                    res.data.shift()

                    // 使用者選擇的end date
                    const userSelectedEndDate = this.getFirstTimeUnitOfDate(this.dateRange[1])
                    // 最後一筆資料的日期
                    const lastDateOfData = this.getFirstTimeUnitOfDate(res.data[res.data.length - 1]['recordedOn'])
                    
                    /* 
                    * 由於API回傳最多只會到今日(週、月、年)
                    * 因此若使用者選擇的「end date的第一個日期」早於相對「最後一筆資料的第一個日期」，則移除往後多撈取的時間單位
                    * 第一個日期：該日期當日、該日期當週週一、該日期當月第一天、該日期當年第一天
                    */
                    console.log('User selected end date', userSelectedEndDate.format('YYYY-MM-DD'))
                    console.log('Last dete of data', lastDateOfData.format('YYYY-MM-DD'))
                    if(userSelectedEndDate.isBefore(lastDateOfData)) {
                        // 由於有往後多撈取一個時間單位，因此移除最後一筆資料
                        res.data.pop()
                    }

                    this.tableData = res.data.reverse()
                }
                else
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' }) 
                }
            })
            .catch( err =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
                console.error(err)
            })
            .finally( () => {
                this.loading = false
                // 重置目前選擇頁數
                this.currentPage = 1
            })
        },
        download()
        {
            // this.loading = true
            // let xlsx_data = []
            // this._.forEach( this.tableData, (e) => {
            //     let row_data = {}
            //     row_data["日期"] = e.recordedOn
            //     row_data["估算用水量(度)"] = e._volume
            //     row_data["較前一日增減"] = e._compareToYesterday
            //     row_data["00時"] = e._rawdata[0]
            //     row_data["01時"] = e._rawdata[1]
            //     row_data["02時"] = e._rawdata[2]
            //     row_data["03時"] = e._rawdata[3]
            //     row_data["04時"] = e._rawdata[4]
            //     row_data["05時"] = e._rawdata[5]
            //     row_data["06時"] = e._rawdata[6]
            //     row_data["07時"] = e._rawdata[7]
            //     row_data["08時"] = e._rawdata[8]
            //     row_data["09時"] = e._rawdata[9]
            //     row_data["10時"] = e._rawdata[10]
            //     row_data["11時"] = e._rawdata[11]
            //     row_data["12時"] = e._rawdata[12]
            //     row_data["13時"] = e._rawdata[13]
            //     row_data["14時"] = e._rawdata[14]
            //     row_data["15時"] = e._rawdata[15]
            //     row_data["16時"] = e._rawdata[16]
            //     row_data["17時"] = e._rawdata[17]
            //     row_data["18時"] = e._rawdata[18]
            //     row_data["19時"] = e._rawdata[19]
            //     row_data["20時"] = e._rawdata[20]
            //     row_data["21時"] = e._rawdata[21]
            //     row_data["22時"] = e._rawdata[22]
            //     row_data["23時"] = e._rawdata[23]
            //     row_data["24時"] = e._rawdata[24]
            //     xlsx_data.push(row_data)
            // })
            // let file_name = this.dateRange[0] + "-" + this.dateRange[1] + "_用水指針查詢_" + this.currentWaterId + ".ods"
            // const wbout = XLSX.utils.book_new()
            // XLSX.utils.book_append_sheet(wbout, XLSX.utils.json_to_sheet(xlsx_data), this.exportDateRange[0] + "~" + this.exportDateRange[1])
            // this.loading = false
            // XLSX.writeFile(wbout, file_name, {bookType:'ods', type:'base64'})
            if( ! _.size(this.dateRange))
            {
                return this.$message({ message: '請選擇時間區間!', type: 'warning' }) 
            }
            let url = "/api/report/profile/" + this.currentWaterId + "/dailyRawdata/download?start=" + this.dateRange[0] + "&end=" + this.dateRange[1] + "&sort=" + this.sortTmp
            this.loading = true
            this.axios.get(url,  {responseType: 'blob'})
            .then( response => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a') // 利用<a>標籤下載
                link.style.display = 'none'
                link.href = url
                let fileName = decodeURI(response.headers['content-disposition'].split(';')[1].split('=')[1])
                let safeFileName  = fileName.replace(/[^a-zA-Z0-9_\-.]/g, '_'); // 20240812 弱掃 Client Dynamic File Inclusion 修正
                link.setAttribute('download', safeFileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
            .catch( err =>
            {
                this.$message({ message: '無法下載資料!', type: 'warning' })
                console.error(err)
            })
            .finally( () => {
                this.loading = false
            })
        },
        async exportReport() {
            if(this.tableData && _.isArray(this.tableData) && this.tableData.length > 0) {
                const reqData = this.tableData.map(e => {
                    return {
                        recordedOn: e['recordedOn'],
                        compareToYesterday: e['_compareToYesterday'].toString(),
                        volume: e['_volume'],
                        rawdata: e['_rawdata'],
                    }
                })
                
                const url = '/api/report/profile/' + this.currentWaterId + '/dailyRawdata/export'
                await this.axios({
                    method: "post",
                    url: url,
                    responseType: "blob", // 設置 responseType 為 'blob'，以處理二進制檔案數據
                    data: reqData,
                }).then((response) => {
                    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a")
                    link.href = downloadUrl
                    // const fileName = `daily-rawdata_${this.$moment()
                    //     .tz("Asia/Taipei")
                    //     .format("YYYYMMDD")}.ods`
                    const fileName = `daily-rawdata.ods`
                    link.setAttribute("download", fileName) // 設置下載檔案的名稱和副檔名
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
            }
        },
        setPage(page)
        {
            this.currentPage = page
        },
        changePages(page)
        {
            this.pageSize = page
        },

        getMajorityDate (data) {
            const dateCounts = {};
            _.forEach(data, (v, k) =>{
                const dateOnly = moment(k).format('YYYY-MM-DD');
                if (dateCounts[dateOnly]) {
                    dateCounts[dateOnly]++;
                } else {
                    dateCounts[dateOnly] = 1;
                }
                
            })
            
            // 找到出現次數最多的日期
            let maxCount = 0;
            let maxDate = '';
            Object.entries(dateCounts).forEach(([date, count]) => {
                if (count > maxCount) {
                    maxCount = count;
                    maxDate = date;
                }
            });
            
            return maxDate; // 多數日期

        },
      webModeCheck() {
        let webModeCheckWidth = this.$parent.$parent.$parent.$parent.getWebModeCheckWidth();
        if(webModeCheckWidth<=0) {
				this.fixedColumns=[true,false,false];
			} else {
				this.fixedColumns=[true,true,true];
			}
		},
		getFixed(idx) {
			return this.fixedColumns[idx];
		},
        async getTimeUnitValue() {
            this.settingData = await viewRuleSetting()
            this.volumeViewTimeUnit = this.settingData.volumeViewTimeUnit

            switch (this.volumeViewTimeUnit) {
                case 'week':
                    this.compareToYesterdayLabel = '較前一週增減'
                    break;
                case 'month':
                    this.compareToYesterdayLabel = '較前一月增減'
                    break;
                case 'year':
                    this.compareToYesterdayLabel = '較前一年增減'
                    break;
                default:
                    this.compareToYesterdayLabel = '較前一日增減'
                    break;
            }
            
        },
        // 取得往前一個時間單位
        getPrevTime(dateStr) {
            let result = null
            const format = 'YYYY-MM-DD'
            switch (this.volumeViewTimeUnit) {
                case 'week':
                    // 前一週的日期
                    result = this.$moment(dateStr).clone().subtract(1, 'weeks').format(format)
                    break
                case 'month':
                    // 前一月的日期
                    result = this.$moment(dateStr).clone().subtract(1, 'months').format(format)
                    break
                case 'year':
                    // 前一年的日期
                    result = this.$moment(dateStr).clone().subtract(1, 'years').format(format)
                    break
                default:
                    // 前一天的日期
                    result = this.$moment(dateStr).clone().subtract(1, 'days').format(format)
                    break
            }

            return result
        },
        // 取得往後一個時間單位
        getNextTime(dateStr) {
            let result = null
            const format = 'YYYY-MM-DD'
            switch (this.volumeViewTimeUnit) {
                case 'week':
                    // 後一週的日期
                    result = this.$moment(dateStr).clone().add(1, 'weeks').format(format)
                    break
                case 'month':
                    // 後一月的日期
                    result = this.$moment(dateStr).clone().add(1, 'months').format(format)
                    break
                case 'year':
                    // 後一年的日期
                    result = this.$moment(dateStr).clone().add(1, 'years').format(format)
                    break
                default:
                    // 後一天的日期
                    result = this.$moment(dateStr).clone().add(1, 'days').format(format)
                    break
            }

            return result
        },
        // 取得相對於輸入日期的第一天(該日期當日、該日期當週週一、該日期當月第一天、該日期當年第一天)
        getFirstTimeUnitOfDate(dateStr) {
            let _momentObj = this.$moment().startOf('day')
            if(dateStr) {
                _momentObj = this.$moment(dateStr)
            }
            
            let result = null
            const tz = 'Asia/Taipei'
            switch (this.volumeViewTimeUnit) {
                case 'week':
                    // 這週的週一
                    result = _momentObj.tz(tz).clone().startOf('isoWeek')
                    break
                case 'month':
                    // 這月的第一天
                    result = _momentObj.tz(tz).clone().startOf('month')
                    break
                case 'year':
                    // 今年的第一天
                    result = _momentObj.tz(tz).clone().startOf('year')
                    break
                default:
                    // 今天
                    result = _momentObj.tz(tz).clone()
            }

            return result
        },
        sortChange({ prop, order }) {
            console.log(`排序属性: ${prop}, 排序方式: ${order}`);
            this.tableData = this.tableData.sort(order == 'descending' ? (a, b) => this.sortItemDown(a, b, prop) : (a, b) => this.sortItemUp(a, b, prop));
        },
        sortItemUp(x, y, prop) {
            this.sortTmp = prop + ',' + 'asc'
            return ((x[prop.replace('_','')] == y[prop.replace('_','')]) ? 0 : ((x[prop.replace('_','')] > y[prop.replace('_','')]) ? 1 : -1));
        },
        sortItemDown(x, y, prop) {
            this.sortTmp = prop + ',' + 'desc'
            return ((x[prop.replace('_','')] == y[prop.replace('_','')]) ? 0 : ((x[prop.replace('_','')] < y[prop.replace('_','')]) ? 1 : -1));
        },
        isNotEmptyButZero(value) {
            return value !== '' && value !== null && value !== undefined
        },
    },
}
</script>
